import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import StoreApplicationState from "@store/Store/StoreApplicationState";

export const ymmdSelector = (state: StoreApplicationState) => {
    return state.store.components.rsswYMMD;
};

export const productListYmmdSelector = (state: StoreApplicationState) => {
    return getPageLinkByPageType(state, "ProductListYmmdPage")?.url;
};

export const productDataViewSelector = (state: StoreApplicationState) => {
    return state.store.components.rsswYMMD.products;
};

export const ymmdAvailableDimensionsSelector = (state: StoreApplicationState) => {
    return state.store.components.rsswYMMD.products.availableDimensions;
};

export const ymmdFitmentsSelector = (state: StoreApplicationState) => {
    return state.store.components.rsswYMMD.fitments;
};
